import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IssueSerialNumberCountDialogProps {
  closeFn: () => void;
  confirmFn: (count: number, quantity: number) => void;
  open: boolean;
}

const IssueSerialNumberCountDialog: FC<IssueSerialNumberCountDialogProps> = ({ closeFn, confirmFn, open }) => {
  const { t } = useTranslation();
  const [count, setCount] = useState<number>(1);
  const [quantity, setQuantity] = useState<number>(1);

  return (
    <Dialog aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description" open={open}>
      <DialogTitle>{t('products.issue serial numbers')}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          value={count}
          type="number"
          variant="outlined"
          label={t('products.serial numbers count')}
          InputProps={{ inputProps: { min: 1, max: 100 } }}
          style={{ marginBottom: '24px' }}
          onChange={event => {
            const value = Number(event.target.value);

            if (!isNaN(value)) {
              setCount(value);
            }
          }}
        />

        <TextField
          fullWidth
          value={quantity}
          type="number"
          variant="outlined"
          label={t('products.product quantity per serial number')}
          InputProps={{ inputProps: { min: 1 } }}
          onChange={event => {
            const value = Number(event.target.value);

            if (!isNaN(value)) {
              setQuantity(value);
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setCount(1);
            setQuantity(1);
            closeFn();
          }}
          color="secondary"
        >
          {t('label.cancel')}
        </Button>
        <Button
          onClick={() => {
            confirmFn(count, quantity);
            setCount(1);
            setQuantity(1);
          }}
          color="primary"
        >
          {t('label.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { IssueSerialNumberCountDialog };
